
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnacknowledgedFill as ObiUnacknowledgedFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-unacknowledged-fill.js';
 
 
 

 
 export const ObiUnacknowledgedFill = createComponent({
   react: React,
   tagName: 'obi-unacknowledged-fill',
   elementClass: ObiUnacknowledgedFillElement,
   events: {
     
   }
  });
 
 